import {areEqual} from "../../common/NamaCommon";
import {translateMessage} from "../../common/Translator";
import {ActionPerformer} from "../../widgets/ActionPerformer";
import {QuestionFieldsEditor} from "../../widgets/QuestionFieldsEditor";
import {ActionHandler} from "../../widgets/ActionHandler";
import {of} from "../../widgets/ActionPlaceholder";
import * as FieldType from "../../constants/FieldType";
import {NamaKendoWindow, NamaWindowBtnData} from "../NamaKendoWindow";

function viewVersion(version, presenter) {
    if (version === -1) {
        let questionFieldsEditor = new QuestionFieldsEditor(presenter.entityType);
        let actionHandler = new ActionHandler();
        actionHandler.performer = new ActionPerformer();
        actionHandler.performer.performAction = () => {
            let filledQuestions = questionFieldsEditor.getQuestionFields();
            if (filledQuestions && filledQuestions.length > 0) {
                let versionNumber = filledQuestions[0];
                presenter.showVersion(versionNumber.value);
            }
        };
        actionHandler.questionFieldsEditor = questionFieldsEditor;
        actionHandler.actionInfo = of("version" + version);
        let questionFields = [];
        let questionField = {};
        questionField.id = "sepecificVersion";
        let metaData = {};
        metaData.id = "sepecificVersion";
        metaData.fieldType = FieldType.Integer;
        questionField.metaData = metaData;
        questionFields.push(questionField);
        let window = new NamaKendoWindow("version" + version, new NamaWindowBtnData("ok", () => {
            actionHandler.performer.performAction(actionHandler.actionInfo.getId(), questionFieldsEditor.getQuestionFields(), presenter.metadata, presenter);
            window.closeWindow();
        }), new NamaWindowBtnData("cancel"));
        questionFieldsEditor.edit(questionFields, null, null, null, presenter, window, window);
        window.showWindow();
    }
    else {
        presenter.showVersion(version);
    }
}

export class ViewVersionMoreMenuItem {
    constructor(version, presenter) {
        this.title = title(version);
        this.id = id(version);
        this.version = version;
        this.presenter = presenter;
        this.clickFunction = () => viewVersion(version, presenter);
    }

    static currentVersion(presenter) {
        return new ViewVersionMoreMenuItem(null, presenter);
    }
    static specificVersion(presenter) {
        return new ViewVersionMoreMenuItem(-1, presenter);
    }

}

function title(version) {
    if (!version)
        return translateMessage("currentVersion");
    else if (version === -1)
        return translateMessage("sepecificVersion");
    else
        return translateMessage("viewVersion", version);
}

function id(version) {
    if (!version)
        return "currentVersion";
    else if (areEqual(version, -1))
        return "sepecificVersion";
    else
        return "viewVersion" + version;
}